import { Heart } from 'lucide-react'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cream via-parchment to-rose-50">
      <div className="text-center">
        <div className="relative inline-block">
          <Heart className="w-16 h-16 text-rose-500 fill-rose-500 animate-pulse" />
          <div className="absolute inset-0 bg-rose-400/30 rounded-full blur-xl animate-ping" />
        </div>
        <p className="mt-6 font-display text-lg text-ink/70">Yükleniyor...</p>
      </div>
    </div>
  )
}
